//// Country Dropdown Js ////
function setCookie(name, value) {
    document.cookie = `${name}=${value}`;
}
function handleChange(newValue) {
    setCookie('birth-control_lastQuestionafter', newValue);
}
function numberChange(lastNumber) {
    setCookie('birth-control_lastNumber', lastNumber);
}


function findMedication(json, medicationName) {
    if (json.hasOwnProperty(medicationName)) {
      return json[medicationName];
    } else {
        return "Medication not found: " + medicationName;
    }
}
function findMedicationSub(json, medicationName, dosage) {
    if (json.hasOwnProperty(medicationName)) {
      if (json[medicationName].hasOwnProperty(dosage)) {
        return json[medicationName][dosage];
      }
    } else {
        return "Medication not found: " + medicationName;
    }
}

function preferredStrength(location,data) {
  $(location).html("");
   const filteredData = Object.fromEntries(
    Object.entries(data).filter(([key, value]) => key && !(key === "skipStrength" && value === "false"))
  );
  var itemCountList = 0;
  $.each(filteredData, function(key, value) {
    if (key != 'url') {
    itemCountList++;
    if (itemCountList == 1) {
      var charAt = 'A'
    }else if (itemCountList == 2) {
      var charAt = 'B'
    }else if (itemCountList == 3) {
      var charAt = 'C'
    }else if (itemCountList == 4) {
      var charAt = 'D'
    }else if (itemCountList == 5) {
      var charAt = 'E'
    }else if (itemCountList == 6) {
      var charAt = 'F'
    }else if (itemCountList == 7) {
      var charAt = 'G'
    }else if (itemCountList == 8) {
      var charAt = 'H'
    }else if (itemCountList == 9) {
      var charAt = 'I'
    }else if (itemCountList == 10) {
      var charAt = 'J'
    }
    const li = $("<li></li>");
      li.html(`
        <input type="checkbox" class="yes_btn" name="option" value="${key}">
        <label for="${key}">
          <div class="opction_btn_main">
            <div class="key_btn">
              <div class="key_helper">
                <div class="key_btn_content">
                  <span class="key_helper_hint_text">Key</span><span class="key_helper_letter">${charAt}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="checkbox_choice_content">
            <div class="text_textwrapper">${key}</div>
          </div>
          <div class="check_mark">
            <span class="icon-check">
              <i class="fal fa-check"></i>
            </span>
          </div>
        </label>
      `);
      $(location).append(li);
    }
  });
  preferredStrengthClick();
}

function extractNoscriptData(htmlString) {
  // Create a temporary DOM element
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;

  // Find the noscript element
  const noscriptElement = tempDiv.querySelector('noscript.product_urls');
  if (!noscriptElement) {
    console.error('Noscript element not found');
    return;
  }

  // Get the JSON data from the noscript element
  const noscriptContent = noscriptElement.textContent.trim();
  let jsonData;
  try {
    jsonData = JSON.parse(noscriptContent);
  } catch (error) {
    console.error('Failed to parse JSON data from noscript:', error);
    return;
  }

  // Return the parsed JSON data
  return jsonData;
}

function findMedicationDosage(json, medicationName, dosage) {
    if (json.hasOwnProperty(medicationName)) {
        if (json[medicationName].hasOwnProperty(dosage)) {
            return json[medicationName][dosage];
        } else {
            return "Dosage not found for " + medicationName;
        }
    } else {
        return "Medication not found: " + medicationName;
    }
}
function findMedicationDosageSub(json, medicationName, dosage, subDosage) {
    if (json.hasOwnProperty(medicationName)) {
        if (json[medicationName].hasOwnProperty(dosage)) {
            return json[medicationName][dosage][subDosage];
        } else {
            return "Dosage not found for " + medicationName;
        }
    } else {
        return "Medication not found: " + medicationName;
    }
}


function pushValueToCookieArray(key, newValue, afterQuestion, lastNumber) {
  var existingCookieValue = document.cookie.replace(new RegExp("(?:(?:^|.*;\\s*)" + key + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1");
  var existingObject = existingCookieValue ? JSON.parse(decodeURIComponent(existingCookieValue)) : {};

  existingObject.items = existingObject.items || [];
  existingObject.items.push(newValue);

  var expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 10); 

  var cookieString = key + "=" + encodeURIComponent(JSON.stringify(existingObject)) + "; expires=" + expirationDate.toUTCString() + "; path=/";
  document.cookie = cookieString;
  handleChange(afterQuestion);
  numberChange(lastNumber);
  
}
function getCookie(key) {
  var cookies = document.cookie.split(';');  
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(key + '=') === 0) {
      return decodeURIComponent(cookie.substring(key.length + 1));
    }
  }
  return null;
}
function deleteCookie(key) {
  var expirationDate = new Date(0); // Set expiration date to a past date
  var cookieString = key + "=; expires=" + expirationDate.toUTCString() + "; path=/";

  document.cookie = cookieString;
}


$('.trigger-icon-button').on('click touch', function() {
    $(".country_dropdown").addClass("select_dropdown_show");
});

$(document).on('click touch', function(event) {
    if (!$(event.target).parents().addBack().is('.trigger-icon-button')) {
        $('.country_dropdown').removeClass('select_dropdown_show');
    }
});

$('.country_dropdown').on('click touch', function(event) {
    event.stopPropagation();
});

$.getJSON('https://cdn.shopify.com/s/files/1/0425/4197/3660/files/custom-countries.json?v=1784870873', function(data) {
    $(".country_list").empty();
    data.sort(function(a, b) {
        return a.name.localeCompare(b.name);
    });
    $.each(data, function(index, item) {
        var html = `
            <div class="country_select_option">
                <div class="country_select_bg">
                    <div class="country_select_wrapper">
                        <span><img src="${item.flag}" alt="${item.name}" style="max-width:28px;"><div class="country_text">${item.name}</div></span>
                        <div class="select_contentText"><div class="country_code">${item.code}</div></div>
                    </div>
                </div>
            </div>
        `;
        $(".country_list").append(html);
    });
    $('.country_select_option').on("click", function () {
        var image = $(this).find("img").attr("src");
        var code = $(this).find(".country_code").text();
        var country = $(this).find(".country_text").text();
        $(".distribute .trigger-icon-button__StrokeIcon img").attr("src", image);
        $(".country_dropdown").removeClass("select_dropdown_show");
        $(".select_country_box input").attr("data-contry-code", code);
        $("#checkNumber").attr("data-contry-code", code);
        $(".form-selected-answer [data-handle='country-code']").val(code);
        $(".selected-country-name").text(country);
    });
});

$("#search_countries").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    $(".country_list .country_select_option").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
});

function shakeEffect($selector) {
    $selector.removeClass('shake_animation');
    setTimeout(function() {
        $selector.addClass('shake_animation');
        setTimeout(function() {
            $selector.removeClass('shake_animation');
        }, 600);
    }, 10);
}

$('.dm-data-validate').keypress(function(e) {
    if (e.which == 13) {
        $(this).parents('.form_loop').find('button').click();
    }
    var $limit = parseInt($(this).attr('maxlength'));
    if ($(this).val().length <= $limit) {} else {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.form_loop textarea').keypress(function(e) {
    if (e.which == 13 && !e.shiftKey) {
        $(this).parents('.form_loop').find('button').click();
        return false;
    }
});

$('.dm-data-validate').keyup(function() {
    var d = new Date();
    var $max = parseInt($(this).attr('max')) || d.getFullYear();

    if ($(this).val() > $max) {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.dm-question').each(function() {
    var $question = $(this).html();
    var $que = $question;
    $que = $que.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    $(this).parents('.form_loop').attr('data-question', $que);
    var $hidden = '<input type="hidden" name="' + $question + '" data-handle="' + $que + '">';
    $('.form-selected-answer').append($hidden);
});

$('.form-selected-answer').append('<input type="hidden" name="country code" data-handle="country-code" value="+61">');
$('.form-selected-answer [data-handle="please-enter-your-medicare-card-details"]').remove();
$('.form-selected-answer [data-handle="what-is-your-ihi"]').remove();

$('.unfortunately_title .back_btn_content button, .book-consiltation-doctor .back_btn_content button').click(function() {
    var Goto = $(this).attr('goto');
    var $indexGoto = $('.form_loop[data-question=' + Goto + ']').index();
    $('.form_loop').removeClass('d-none').removeClass('d-block');

    var $limit = $('.form_loop').length;
    for (i = 0; i < $limit; i++) {
        if (i == $indexGoto) {
            $('.form_loop[data-question=' + Goto + ']').addClass('d-block').animate({
                scrollTop: 0
            });
            break;
        } else {
            var j = i + 1;
            $('.form_loop:nth-child(' + j + ')').addClass('d-none');
        }
    }
});

$('.form_loop input[type=checkbox]').click(function() {
    var Name = $(this).attr('name');
    var $parent = $(this).parents('.form_loop');
    $parent.find('input[name=' + Name + ']:checked').not(this).prop('checked', false);
});

//   FIRST YES BTN
$('.first_questions_section .form_action_btn').click(function() {
    $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().addClass('d-block');
    $('.progress_content').show();
    pushHistory(1);
    $('html, body').animate({
      scrollTop: 0
    }, 800);
    var cookieToDelete = 'birth-control';
    deleteCookie(cookieToDelete);
    deleteCookie("birth-control_lastQuestionafter");
});

$('.continue_btn_content .continue_action_btn').click(function() {
  var weightLossCookieValue = getCookie('birth-control_lastQuestionafter');
  var weightLosslatnumCookieValue = getCookie('birth-control_lastNumber');
  
  if (weightLossCookieValue !== null) {

    $(this).parents('.form_loop').removeClass('d-block').addClass('d-none');
    
    $('.questionnaire_form_main .form_loop').each(function(){
      var selfQuestions = $(this).data('question');
      if(selfQuestions == weightLossCookieValue){
          $(this).addClass('d-block').find('.number').html(weightLosslatnumCookieValue);
      }
    });
  }
});


const getQuestion = {
  que1: "do-any-of-the-listed-medical-conditions-apply-to-you",
  que2: "do-any-of-the-following-apply-to-you",
  que3: "did-your-last-menstrual-period-start-within-the-past-7-days",
  que4: "have-you-abstained-from-sexual-intercourse-since-your-last-menstrual-period-or-delivery",
  que5: "have-you-had-a-miscarriage-or-abortion-in-the-last-7-days",
  que6: "is-there-any-history-of-pco-endometriosis",
  que7: "have-you-been-using-a-reliable-contraceptive-method-consistently-and-correctly",
  // que8: "what-brand-of-pill-have-you-been-using-any-side-effects",
  que8: "what-brand-have-you-been-using-any-side-effects",
  // que9: "what-brand-of-pill-are-you-after",
  que9: "what-brand-are-you-after",
  que10: "is-there-anything-you-would-like-to-tell-your-doctor",
  // que11: "do-you-acknowledge-that-taking-the-pill-still-has-the-risk-of-falling-pregnant-there-is-no-protection-against-std-and-you-need-to-follow-up-with-your-gp-for-bp-weight-check-and-smear-test-you-also-need-to-read-the-potential-side-effects-of-the-pill-from-product-information",
  que11: "do-you-acknowledge-that-your-contraception-still-has-the-risk-of-falling-pregnant-there-is-no-protection-against-std-and-you-need-to-follow-up-with-your-gp-for-bp-weight-check-and-smear-test-you-also-need-to-read-the-potential-side-effects-of-your-contraception-from-the-product-information",
  que12: "discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id",
  que13: "please-enter-your-date-of-birth",
  que14: "based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment",
  que15: "do-you-have-a-medicare-card",
  que16: "please-enter-your-medicare-card-details",
  que17: "what-is-your-ihi",
  que18: "have-you-recently-had-your-blood-pressure-checked",
  que19: "what-was-your-recent-blood-pressure-reading",
  que20: "please-enter-your-height-in-centimetres-and-weight-in-kilograms",
  que21: "enter-the-name-of-medication-below",
  que22: "please-select-your-preferred-strength",
  que23: "do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues",
  que24: "please-list-any-regular-medications-you-take-any-known-allergies-or-any-medical-issues",
  que25: "do-you-have-a-medication-preference",
  que26: "would-you-like-to-skip-the-questionnaire-and-speak-with-a-doctor-or-nurse-practitioner-instead"
}

$('.form-selected-answer input[type="hidden"]').each(function(){
  var selfHandle = $(this).attr('data-handle');
  var weightLossCookieValue = getCookie('birth-control');
  if (weightLossCookieValue !== null) {
      $('.continue_btn_content').removeClass('hidden');
      var weightLossObject = JSON.parse(weightLossCookieValue);
      var weightLossObjectItem = weightLossObject.items;
      for (var i = 0; i < weightLossObjectItem.length; i++) {
      var currentObject = weightLossObjectItem[i];
      for (var key in currentObject) {
        if (currentObject.hasOwnProperty(key)) {
          var cookieValue = currentObject[key];
          if(key == selfHandle){
            $('.form-selected-answer [data-handle=' + key + ']').val(cookieValue);
          }else{
            if($('#callback-form input[data-handle="'+key+'"]').length == 0){
              var getName = $(".form_loop[data-question='"+ key +"' ] .dm-question").text();
              var getQuestion = getName;
              $('.form-selected-answer').append('<input type="hidden" name="'+getQuestion+'" data-handle="'+key+'">');
              $('.form-selected-answer [data-handle=' + key + ']').val(cookieValue);
            }
          }
        }
      }
    }
    
    if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'no' || $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'No'){
        if($('#callback-form input[data-handle="what-is-your-ihi"]').length == 0){ 
          $('.form-selected-answer').append('<input type="hidden" name="What is your IHI?" data-handle="what-is-your-ihi">');
        }
     }else if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'yes' || $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'Yes'){
       if($('#callback-form input[data-handle="please-enter-your-medicare-card-details"]').length == 0){ 
          $('.form-selected-answer').append('<input type="hidden" name="Please enter your Medicare Card details" data-handle="please-enter-your-medicare-card-details">');
          var irnHtml = '<input type="hidden" name="irn_number" data-handle="do-you-have-a-medicare-card_irn">',
              cardNumberHtml = '<input type="hidden" name="medicare-card_number" data-handle="do-you-have-a-medicare-card_number">',
              monthYearHtml = '<input type="hidden" name="medicare-card_month_year" data-handle="do-you-have-a-medicare-card_month_year">';
          $('.form-selected-answer').append([irnHtml, cardNumberHtml, monthYearHtml]);
       }
     }
    
  }
});

$('.form-selected-answer [data-handle=' + getQuestion.que20 + ']').after('<input type="hidden" name="What is your BMI?" data-handle="what-is-your-bmi" value="">');

var json;
function handleResponse() {
    const data = JSON.parse(this.responseText);
    const extractedData = extractNoscriptData(data['search-product-list-8']);
    json = extractedData;
    var medication = $('.form-selected-answer [data-handle=' + getQuestion.que21 + ']').val();
    var getData = findMedication(json, medication);
    preferredStrength($(".form_loop[data-question='please-select-your-preferred-strength'] .maintaining_option ul"),getData);
}

const request = new XMLHttpRequest();
request.addEventListener('load', handleResponse);
request.open('GET', 'https://bursthealth.com.au/pages/product-search-data?sections=search-product-list-8', true);
request.send();

if ($('.form-selected-answer [data-handle=' + getQuestion.que26 + ']').val() == 'Yes') {
  $(".ihi_question .form_submit_btn").addClass("hide_btn");
  $(".ihi_question .form_next_btn").removeClass("hide_btn");
}else {
  $(".ihi_question .form_submit_btn").removeClass("hide_btn");
  $(".ihi_question .form_next_btn").addClass("hide_btn");
}

$('.form_loop[data-question=' + getQuestion.que26 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + getQuestion.que26 + ']').val($this.val());
          if ($this.val() == 'Yes') {
            $(".ihi_question .form_submit_btn").addClass("hide_btn");
            $(".ihi_question .form_next_btn").removeClass("hide_btn");
            var newValue = { 'would-you-like-to-skip-the-questionnaire-and-speak-with-a-doctor-or-nurse-practitioner-instead': $this.val()};
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
            $('.form_loop[data-question="discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id"]').data("question");
            pushHistory($currentNumber + 1);
            CalculateP();
            
          }else {
            var bmival = parseFloat($('.bmi-value').val());
            if(bmival > 35){
               $(".ihi_question .form_submit_btn").removeClass("hide_btn");
               $(".ihi_question .form_next_btn").addClass("hide_btn"); 
            }else{
              if($(`.form-selected-answer [data-handle=${getQuestion.que1}]`).val() == 'Yes'){
                $(".ihi_question .form_submit_btn").removeClass("hide_btn");
                $(".ihi_question .form_next_btn").addClass("hide_btn"); 
              }else{
                $(".ihi_question .form_submit_btn").addClass("hide_btn");
               $(".ihi_question .form_next_btn").removeClass("hide_btn"); 
              }
            }
            
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
            $('.form_loop[data-question="do-any-of-the-listed-medical-conditions-apply-to-you"]').addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var afterlastQuestion = $('.form_loop[data-question="do-any-of-the-listed-medical-conditions-apply-to-you"]').data("question");
          }
          
            pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});


function weightLossQestion() {
  $('.form_loop[data-question=' + getQuestion.que21 + '] .custom_select_button').click(function() {
      ValidateRemove();
      var $this = $(this),
          $parent = $this.parents('.form_loop'),
          $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        console.log(this,`$(".search-bar:not(.drawer) .predictive-search")$(".search-bar:not(.drawer) .predictive-search")`)
          $('.form-selected-answer [data-handle=' + getQuestion.que21 + ']').val($this.val());
          var medication = $this.val();
          var getData = findMedication(json, medication);
          var newValue = { 'enter-the-name-of-medication-below': $this.val()};
        
            if (getData.skipStrength == "true") {
              $('#callback-form').submit();
              var afterlastQuestion = "";
            } else {
              preferredStrength($(".form_loop[data-question='please-select-your-preferred-strength'] .maintaining_option ul"),getData)
              $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
              var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            }
            pushHistory($currentNumber + 1);
            CalculateP();
              pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);
      }, 100);
  });
}


setTimeout(()=>{
  weightLossQestion();
}, 4000);


function preferredStrengthClick() {
$('.form_loop[data-question=' + getQuestion.que22 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {      
      if ($parent.find('input[name=' + Name + ']:checked').length) {
          $('.form-selected-answer [data-handle=' + getQuestion.que22 + ']').val($this.val());

        if ($this.val() == '40 Mg') {
          $('.form-selected-answer').append('<input type="hidden" name="Have you taken 40mg before?" data-handle="have-you-taken-40mg-before">');          
          var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
        }else {
          $('#callback-form').submit();
        }
           var newValue = { 'please-select-your-preferred-strength': $this.val()};
              pushHistory($currentNumber + 1);
              CalculateP();
          pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);
      }
    }, 100);
});
}
preferredStrengthClick();

$('.form_loop[data-question=' + getQuestion.que23 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + getQuestion.que23 + ']').val($this.val());
           var newValue = { 'do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues': $this.val()};
          if ($this.val() == 'Yes') {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          }else {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
            $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').data("question");
          }
          
            pushHistory($currentNumber + 1);
            CalculateP();
            pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});


$('.form_loop[data-question=' + getQuestion.que24 + '] button').click(function() {
      ValidateRemove();  
      var $this = $(this),
          Name = $this.attr('name'),
          $parent = $this.parents('.form_loop'),
          $currentNumber = parseInt($parent.find('.number').html()),
          $value = $parent.find('textarea').val(),
          $value = $value.trim();
      if ($value.length) {
          $('.form-selected-answer [data-handle=' + getQuestion.que24 + ']').val($value);
          var newValue = { 'please-list-any-regular-medications-you-take-any-known-allergies-or-any-medical-issues': $value };
          $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
          $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').addClass('d-block').find('.number').html($currentNumber + 1);
          var afterlastQuestion = $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').data("question");
        
          pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);  
          pushHistory($currentNumber + 1);
          CalculateP();
      } else {
          shakeEffect($parent);
          $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
          setTimeout(function() {
              $('.valid_date_text').remove();
          }, 2500);
      }
  });
$('.form_loop[data-question=' + getQuestion.que25 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + getQuestion.que25 + ']').val($this.val());
          if ($this.val() == 'Yes') {
            var newValue = { 'do-you-have-a-medication-preference': $this.val()};
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          }else {
            $('#callback-form').submit();
            var afterlastQuestion = "";
          }
          
            pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});






//  STEP 1
$(`.form_loop[data-question=${getQuestion.que1}] .form_action_btn, .form_loop[data-question=${getQuestion.que1}] input[type=checkbox]`).click(function() {
        var getdataque = $(this).parents('.maintaining_que').attr('data-question');
        ValidateRemove();
        var $parent = $(this).parents('.form_loop'),
            $this = $(this);
        setTimeout(function() {
            if ($parent.find('input[type=checkbox]:checked').length) {
                var $currentNumber = parseInt($parent.find('.number').html()),
                    $value = $parent.find('input[type=checkbox]:checked').val();

                    var newValue = { 'do-any-of-the-listed-medical-conditions-apply-to-you': $value };
                    var afterlastQuestion = $parent.next().data("question")
                    pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);
                    
              
                    $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                    $(`.form-selected-answer [data-handle=${getdataque}]`).val($value);
                    pushHistory($currentNumber + 1);
                    CalculateP();
              
                if ($value == "Yes") {
                    $('#BrandPill').html(`<option value="Slinda">Slinda</option><option value="Microlut">Microlut</option>`)
                }
            } else {
                $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
                shakeEffect($(this).parents('.form_loop'));
            }
        }, 500);
    });

//  STEP 2
$(`.form_loop[data-question=${getQuestion.que2}] .form_action_btn, .form_loop[data-question=${getQuestion.que2}] input[type=checkbox]`).click(function() {
        var getdataque = $(this).parents('.maintaining_que').attr('data-question');
        ValidateRemove();
        var $parent = $(this).parents('.form_loop'),
            $this = $(this);
        setTimeout(function() {
            if ($parent.find('input[type=checkbox]:checked').length) {
                var $currentNumber = parseInt($parent.find('.number').html()),
                    $value = $parent.find('input[type=checkbox]:checked').val();
                    var newValue = { 'do-any-of-the-following-apply-to-you': $value };
                if ($value == "Yes") {
                    CalculateP();
                    $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                    $('.unfortunately_title').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                    $('.progress_content .progress_title span').html('100');
                    $('#form_progress_bar').css('width', '100%');
                } else {
                    $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                    $(`.form-selected-answer [data-handle=${getdataque}]`).val($value);
                    pushHistory($currentNumber + 1);
                    CalculateP();
                    var afterlastQuestion = $parent.next().data("question");
                    pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);
                }
            } else {
                $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
                shakeEffect($(this).parents('.form_loop'));
            }
        }, 500);
    });


$(`.form_loop[data-question=${getQuestion.que18}] .form_action_btn, .form_loop[data-question=${getQuestion.que18}] input[type=checkbox]`).click(function() {
        var getdataque = $(this).parents('.maintaining_que').attr('data-question');
        ValidateRemove();
        var $parent = $(this).parents('.form_loop'),
            $this = $(this),
            nextQuestionHide = $(".form-selected-answer [data-handle="+getQuestion.que19+"]").detach();
        setTimeout(function() {
            if ($parent.find('input[type=checkbox]:checked').length) {
                var $currentNumber = parseInt($parent.find('.number').html()),
                    $value = $parent.find('input[type=checkbox]:checked').val();
                    var newValue = { 'have-you-recently-had-your-blood-pressure-checked': $value };
                if ($value == "Yes") {
                  $(".form-selected-answer [data-handle="+getQuestion.que18+"]").after(nextQuestionHide);
                    CalculateP();
                    $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                    $('.blood_pressure').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                    $('.progress_content .progress_title span').html('100');
                    $('#form_progress_bar').css('width', '100%');
                    var afterlastQuestion = $('.blood_pressure').data("question");
                } else {
                    $parent.removeClass('d-block').addClass('d-none').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                    pushHistory($currentNumber + 1);
                    CalculateP();
                    var afterlastQuestion = $parent.next().next().data("question");
                }
                pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);
                    $(`.form-selected-answer [data-handle=${getdataque}]`).val($value);
            } else {
                $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
                shakeEffect($(this).parents('.form_loop'));
            }
        }, 500);
    });
  
$('.form_loop[data-question=' + getQuestion.que19 + '] button').click(function() {
        ValidateRemove();
        var getdataque = $(this).parents('.maintaining_que').attr('data-question');
        var $this = $(this),
            Name = $this.attr('name'),
            $parent = $this.parents('.form_loop'),
            $currentNumber = parseInt($parent.find('.number').html()),
            $value = $parent.find('textarea').val(),
            $value = $value.trim();
        var newValue = { 'what-was-your-recent-blood-pressure-reading': $value };
        if ($value.length) {
            $('.form-selected-answer [data-handle=' + getQuestion.que19 + ']').val($value);
            setTimeout(function() {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);  
            }, 500);
        } else {
            shakeEffect($parent);
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            setTimeout(function() {
                $('.valid_date_text').remove();
            }, 2500);
        }
    });

$('.form_loop[data-question='+getQuestion.que20+'] button').click(function(){
    const BMIHeight = $('#BMIForm-height').val();
    const BMIWeight = $('#BMIForm-weight').val();
    var BMI;
    if (BMIHeight != "" && BMIWeight != "") {
      const BMII = (BMIWeight / BMIHeight ** 2 ) * 10000;
      BMI = BMII.toFixed(2);
      $('.bmi-value').val(BMI);
      $('.form-selected-answer [data-handle="what-is-your-bmi"]').val(BMI);
    }
  
      ValidateRemove();
      var $this = $(this),
          Name = $this.attr('name'),
          $parent = $this.parents('.form_loop'),
          $currentNumber = parseInt($parent.find('.number').html());
      var $value;
      if ($parent.find('.bmi-value').val() != ""){      
        var $value = $parent.find('.bmi-value').val(),
            $value = $value.trim(),
            $value = parseFloat($value);
      }

      if ($value != undefined) {
        $('.form-selected-answer [data-handle='+getQuestion.que20+']').val(BMIHeight + ' height - '+BMIWeight +' weight');
        
        if($value >= 35){
          $(`.form_loop[data-question=${getQuestion.que9}]`).find("select option").not("select option[value='Microlut']").remove();
        } else{
          $(`.form_loop[data-question=${getQuestion.que9}]`).find("select option[value='Microlut']").remove();
        }
    
    
         setTimeout(function(){
          var newValue = { 'please-enter-your-height-in-centimetres-and-weight-in-kilograms': $value };
          var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);  
          $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber+1);
          pushHistory($currentNumber+1);
          CalculateP();
        },500);
        
      } else{
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('.calculator_data'));
        setTimeout(function(){ $('.valid_date_text').remove(); },2500);
      }
     
    });


//  STEP 3
$(`.form_loop[data-question=${getQuestion.que3}] .form_action_btn, .form_loop[data-question=${getQuestion.que3}] input[type=checkbox]`).click(function() {
        var getdataque = $(this).parents('.maintaining_que').attr('data-question');
        ValidateRemove();
        var $parent = $(this).parents('.form_loop'),
            $this = $(this);
        setTimeout(function() {
            if ($parent.find('input[type=checkbox]:checked').length) {
                var $currentNumber = parseInt($parent.find('.number').html()),
                    $value = $parent.find('input[type=checkbox]:checked').val();

                var newValue = { 'did-your-last-menstrual-period-start-within-the-past-7-days': $value };
                var afterlastQuestion = $parent.next().data("question");
                pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);  
              
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $(`.form-selected-answer [data-handle=${getdataque}]`).val($value);
                pushHistory($currentNumber + 1);
                CalculateP();

                

            } else {
                $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
                shakeEffect($(this).parents('.form_loop'));
            }
        }, 500);
    });

//  STEP 4
$(`.form_loop[data-question=${getQuestion.que4}] .form_action_btn, .form_loop[data-question=${getQuestion.que4}] input[type=checkbox]`).click(function() {
        var getdataque = $(this).parents('.maintaining_que').attr('data-question');
        ValidateRemove();
        var $parent = $(this).parents('.form_loop'),
            $this = $(this);
        setTimeout(function() {
            if ($parent.find('input[type=checkbox]:checked').length) {
                var $currentNumber = parseInt($parent.find('.number').html()),
                    $value = $parent.find('input[type=checkbox]:checked').val();

                var newValue = { 'have-you-abstained-from-sexual-intercourse-since-your-last-menstrual-period-or-delivery': $value };
                var afterlastQuestion = $parent.next().data("question");
                pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);  

                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $(`.form-selected-answer [data-handle=${getdataque}]`).val($value);
                pushHistory($currentNumber + 1);
                CalculateP();

            } else {
                $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
                shakeEffect($(this).parents('.form_loop'));
            }
        }, 500);
    });

//  STEP 5
$(`.form_loop[data-question=${getQuestion.que5}] .form_action_btn, .form_loop[data-question=${getQuestion.que5}] input[type=checkbox]`).click(function() {
        var getdataque = $(this).parents('.maintaining_que').attr('data-question');
        ValidateRemove();
        var $parent = $(this).parents('.form_loop'),
            $this = $(this);
        setTimeout(function() {
            if ($parent.find('input[type=checkbox]:checked').length) {
                var $currentNumber = parseInt($parent.find('.number').html()),
                    $value = $parent.find('input[type=checkbox]:checked').val();

                var newValue = { 'have-you-had-a-miscarriage-or-abortion-in-the-last-7-days': $value };
                var afterlastQuestion = $parent.next().data("question");
                pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);  

                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $(`.form-selected-answer [data-handle=${getdataque}]`).val($value);
                pushHistory($currentNumber + 1);
                CalculateP();

            } else {
                $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
                shakeEffect($(this).parents('.form_loop'));
            }
        }, 500);
    });

//  STEP 6
$(`.form_loop[data-question=${getQuestion.que6}] .form_action_btn, .form_loop[data-question=${getQuestion.que6}] input[type=checkbox]`).click(function() {
        var getdataque = $(this).parents('.maintaining_que').attr('data-question');
        ValidateRemove();
        var $parent = $(this).parents('.form_loop'),
            $this = $(this);
        setTimeout(function() {
            if ($parent.find('input[type=checkbox]:checked').length) {
                var $currentNumber = parseInt($parent.find('.number').html()),
                    $value = $parent.find('input[type=checkbox]:checked').val();

                var newValue = { 'is-there-any-history-of-pco-endometriosis': $value };
                var afterlastQuestion = $parent.next().data("question");
                pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1); 

                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $(`.form-selected-answer [data-handle=${getdataque}]`).val($value);
                pushHistory($currentNumber + 1);
                CalculateP();

            } else {
                $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
                shakeEffect($(this).parents('.form_loop'));
            }
        }, 500);
    });

//  STEP 7
$(`.form_loop[data-question=${getQuestion.que7}] .form_action_btn, .form_loop[data-question=${getQuestion.que7}] input[type=checkbox]`).click(function() {
        var getdataque = $(this).parents('.maintaining_que').attr('data-question');
        ValidateRemove();
        var $parent = $(this).parents('.form_loop'),
            $this = $(this);
        setTimeout(function() {
            if ($parent.find('input[type=checkbox]:checked').length) {
                var $currentNumber = parseInt($parent.find('.number').html()),
                    $value = $parent.find('input[type=checkbox]:checked').val();
                    var newValue = { 'have-you-been-using-a-reliable-contraceptive-method-consistently-and-correctly': $value };
                if ($value == "Yes") {
                    $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                    var afterlastQuestion = $parent.next().data("question");
                } else {
                    $parent.removeClass('d-block').addClass('d-none').next().next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                    var afterlastQuestion = $parent.next().next().data("question");
                }
                pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1); 
                $(`.form-selected-answer [data-handle=${getdataque}]`).val($value);
                pushHistory($currentNumber + 1);
                CalculateP();
            } else {
                $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
                shakeEffect($(this).parents('.form_loop'));
            }
        }, 500);
    });

//  STEP 8
$('.form_loop[data-question=' + getQuestion.que8 + '] button').click(function() {
        ValidateRemove();
        var getdataque = $(this).parents('.maintaining_que').attr('data-question');
        var $this = $(this),
            Name = $this.attr('name'),
            $parent = $this.parents('.form_loop'),
            $currentNumber = parseInt($parent.find('.number').html()),
            $value = $parent.find('textarea').val(),
            $value = $value.trim();
        if ($value.length) {
            $('.form-selected-answer [data-handle=' + getQuestion.que8 + ']').val($value);
            setTimeout(function() {
                var newValue = { 'what-brand-have-you-been-using-any-side-effects': $value };
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1); 
                // $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
              
                pushHistory($currentNumber + 1);
                CalculateP();
            }, 500);
        } else {
            shakeEffect($parent);
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            setTimeout(function() {
                $('.valid_date_text').remove();
            }, 2500);
        }
});

// Select DropDown
$('.form_loop[data-question=' + getQuestion.que9 + '] button').click(function() {
    ValidateRemove();
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $('#BrandPill option:selected').attr('value'),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + getQuestion.que9 + ']').val($value);
        setTimeout(function() {
            var newValue = { 'what-brand-are-you-after': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1); 
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

//  STEP 10
$('.form_loop[data-question=' + getQuestion.que10 + '] button').click(function() {
        ValidateRemove();
        var getdataque = $(this).parents('.maintaining_que').attr('data-question');
        var $this = $(this),
            Name = $this.attr('name'),
            $parent = $this.parents('.form_loop'),
            $currentNumber = parseInt($parent.find('.number').html()),
            $value = $parent.find('textarea').val(),
            $value = $value.trim();
        if ($value.length) {
            $('.form-selected-answer [data-handle=' + getQuestion.que10 + ']').val($value);
            setTimeout(function() {
                var newValue = { 'is-there-anything-you-would-like-to-tell-your-doctor': $value };
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
                pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1); 
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
            }, 500);
        } else {
            shakeEffect($parent);
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            setTimeout(function() {
                $('.valid_date_text').remove();
            }, 2500);
        }
});

//  STEP 11
$(`.form_loop[data-question=${getQuestion.que11}] .form_action_btn, .form_loop[data-question=${getQuestion.que11}] input[type=checkbox]`).click(function() {
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();
            if ($value == "Yes") {
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $(`.form-selected-answer [data-handle=${getdataque}]`).val($value);
                pushHistory($currentNumber + 1);
                var newValue = { 'do-you-acknowledge-that-your-contraception-still-has-the-risk-of-falling-pregnant-there-is-no-protection-against-std-and-you-need-to-follow-up-with-your-gp-for-bp-weight-check-and-smear-test-you-also-need-to-read-the-potential-side-effects-of-your-contraception-from-the-product-information': $value };
                var afterlastQuestion = $parent.next().data("question");
                pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1); 
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                $('.unfortunately_title').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                $('.progress_content .progress_title span').html('100');
                $('#form_progress_bar').css('width', '100%');
            }
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

//  STEP 12
$('.form_loop[data-question=' + getQuestion.que12 + '] button').click(function() {
    ValidateRemove();
    var getdataque = $(this).parents('.maintaining_que').attr('data-question');
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + getQuestion.que12 + ']').val($value);
        setTimeout(function() {

          if ($('.form-selected-answer [data-handle=' + getQuestion.que26 + ']').val() == 'Yes') {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
            $('.form_loop[data-question="please-enter-your-date-of-birth"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="please-enter-your-date-of-birth"]').data("question");
          }else { 
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
          }

          
            var newValue = { 'discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id': $value };
            pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1); 
            pushHistory($currentNumber + 1);
            CalculateP();
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

// Date of Birth.
$('.form_loop[data-question=' + getQuestion.que13 + '] .form_action_btn').click(function() {
    ValidateRemove();
    $('.dm-error').remove();
    var $MM = $('.birth_date_field .month input').val(),
        $DD = $('.birth_date_field .day input').val(),
        $YY = $('.birth_date_field .year input').val();
    var InputDate = new Date($MM + '/' + $DD + '/' + $YY);
    var Today = new Date();
    var $currentNumber = parseInt($(this).parents('.form_loop').find('.number').html());

    var Difference_In_Time = Today.getTime() - InputDate.getTime();

    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24 * 365);

    if (Difference_In_Days >= 18 && ($MM.length <= 2 && $DD.length <= 2 && $YY.length == 4)) {

      if ($('.form-selected-answer [data-handle=' + getQuestion.que26 + ']').val() == 'Yes') {
        $(this).parents('.form_loop').addClass('d-none').removeClass('d-block');
        $('.form_loop[data-question="do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues"]').addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $('.form_loop[data-question="do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues"]').data("question");
      }else {
        $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $(this).parents('.form_loop').next().data("question");
      }      

      
        var newValue = { 'please-enter-your-date-of-birth': $DD + '/' + $MM + '/' + $YY };
        pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1); 
        pushHistory($currentNumber + 1);
        $('.form-selected-answer [data-handle=please-enter-your-date-of-birth]').val($DD + '/' + $MM + '/' + $YY);
        CalculateP();
    } else {
        shakeEffect($(this).parents('.form_loop'));
        $($('#error-template').html()).insertAfter($(this).parents('.form_loop').find('.birth_date_field'));
        setTimeout(function() {
            $('.valid_date_text').remove();
        }, 2500);
    }
});

//  STEP 14
$('.form_loop[data-question=' + getQuestion.que14 + '] button').click(function() {
  ValidateRemove();
  var $this = $(this),
      $parent = $this.parents('.form_loop'),
      $currentNumber = parseInt($(this).parents('.form_loop').find('.number').html());
  if($parent.find('.select_country_box input').val().length > 9){
    // $this.attr('disabled','disabled');
    var $value = $parent.find('.select_country_box input').val(),
        Ccode = $parent.find('.select_country_box input').data('contry-code');

    $('.form-selected-answer [data-handle=country-code]').val(Ccode);
    $('#checkNumber').val($value);
    $('#confirmation_popup').toggle();
    CalculateP();
    // $('.form-selected-answer [data-handle=' + getQuestion.que14 + ']').val($value);
    // $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber+1);
  } else{
    shakeEffect($parent);
    $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
    setTimeout(function(){ $('.valid_date_text').remove(); },2500);
  }
});

function otpAfterClick() {
$('#confirmation_popup .confirm_button').click(function(){
   var checkVal = $(this).parents('#confirmation_popup').find('#checkNumber').val();
   var $currentNumber = parseInt($('.form_loop[data-question=' + getQuestion.que14 + ']').find('.number').html());
   if (checkVal.length > 9) {
    $('#confirmation_popup').toggle();

     if ($('.form-selected-answer [data-handle=' + getQuestion.que26 + ']').val() == 'Yes') {
        $('.form_loop[data-question=' + getQuestion.que14 + '] button').parents('.form_loop').addClass('d-none').removeClass('d-block')
        $('.form_loop[data-question="do-you-have-a-medicare-card"]').addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medicare-card"]').data("question");
     }else{
        $('.form_loop[data-question=' + getQuestion.que14 + '] button').parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1)
        var afterlastQuestion = $('.form_loop[data-question=' + getQuestion.que14 + '] button').parents('.form_loop').next().data("question");
     }

     
    $('.form-selected-answer [data-handle=' + getQuestion.que14 + ']').val(checkVal);
    $('.form_loop[data-question=' + getQuestion.que14 + '] button').find('input').val(checkVal);
    var newValue = { 'based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment': checkVal };
    pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1); 
   }else {
      $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
      setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
      shakeEffect($parent);
   }
})
}
otpAfterClick()

// STEP ?
$('.form_loop[data-question="do-you-have-a-medicare-card"] .maintaining_option input[type=checkbox]').click(function(){
  ValidateRemove();
  var $parent = $(this).parents('.form_loop'),
      $this = $(this);
  
  setTimeout(function(){
    if($parent.find('input[type=checkbox]:checked').length){
      var $currentNumber = parseInt($parent.find('.number').html()),
          $value = $parent.find('input[type=checkbox]:checked').val();

      var newValue = { 'do-you-have-a-medicare-card': $this.val() };
	  
      if($value == "yes" || $value == "Yes"){
        $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber+1);
     
        var irnHtml = '<input type="hidden" name="irn_number" data-handle="do-you-have-a-medicare-card_irn">',
            cardNumberHtml = '<input type="hidden" name="medicare-card_number" data-handle="do-you-have-a-medicare-card_number">',
            monthYearHtml = '<input type="hidden" name="medicare-card_month_year" data-handle="do-you-have-a-medicare-card_month_year">';
		
        $('.form-selected-answer').append('<input type="hidden" name="Please enter your Medicare Card details" data-handle="please-enter-your-medicare-card-details">');
        $('.form-selected-answer').append([irnHtml,cardNumberHtml,monthYearHtml]);
        var afterlastQuestion = $parent.next().data("question");

      } else{
         $('.form-selected-answer').append('<input type="hidden" name="What is your IHI?" data-handle="what-is-your-ihi">');
         $parent.addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber+1);
         var afterlastQuestion = $parent.next().next().data("question");
      }
      pushValueToCookieArray('birth-control', newValue, afterlastQuestion, $currentNumber + 1);  
      $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val($value);
      pushHistory($currentNumber+1);
      CalculateP();
    } else{
      $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
      shakeEffect($(this).parents('.form_loop'));
    }
  },500);
});

// STEP ??
$('.form_loop[data-question="please-enter-your-medicare-card-details"] button').click(function(){
  ValidateRemove();
  var $this = $(this),
      $parent = $this.parents('.form_loop'),
      $currentNumber = parseInt($parent.find('.number').html());
  
  var $MM = $('.card_years_field .month input').val(),
      $YY = $('.card_years_field .year input').val(),
  	  $INR = $parent.find('.details_filed input.enter_irn_number').val(),
      $CardNumber = $parent.find('.details_filed input.enter_card_number').val();
  
  if ($parent.find('.details_filed input.enter_irn_number').val().length == 1 && $parent.find('.details_filed input.enter_card_number').val().length == 10 && $MM <= 12 && $MM != '' && $YY != ''){
      $parent.addClass('d-none').removeClass('d-block');
      $('.neurological_que[data-question="appoinment"]').addClass('d-block');
    $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_irn"]').val($INR);
    $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_number"]').val($CardNumber);
    $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_month_year"]').val(`${$MM}/${$YY}`);

    
    var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medication-preference"]').data("question");

    var newValue = { 'do-you-have-a-medicare-card_irn': $INR };
                pushValueToCookieArray('birth-control', newValue,afterlastQuestion);

    var newValue = { 'do-you-have-a-medicare-card_number': $CardNumber };
                pushValueToCookieArray('birth-control', newValue,afterlastQuestion);

    var newValue = { 'do-you-have-a-medicare-card_month_year': $MM+ "/" +$YY };
                pushValueToCookieArray('birth-control', newValue,afterlastQuestion, $currentNumber + 1);

    const getValIs = $('.form-selected-answer [data-handle=what-brand-are-you-after]').val();
    function containsAll(needles, haystack) {
        for (var i = 0; i < needles.length; i++) {
            if ($.inArray(needles[i], haystack) == -1) return false;
        }
        return true;
    }

    if ($('.form-selected-answer [data-handle=' + getQuestion.que26 + ']').val() == 'Yes') {
      $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
      $('.form_loop[data-question="do-you-have-a-medication-preference"]').addClass('d-block').find('.number').html($currentNumber + 1);
    }else {
      // $('#callback-form').submit();
      if (containsAll([getValIs], ['Yasmin','Yaz','Microgynon 20 ED','Micronelle 20 ED','Nextstellis','Nuvaring','Estelle 35','Slinda','Zoely','Madeline'])) {
        $('#callback-form').submit();  
      } else if (containsAll([getValIs], ['Lenest 20 ED','Loette','Diane 35','Brenda 35','Petibelle'])) {
        $('#callback-form').submit();  
      } else if (containsAll([getValIs], ['Levlen ED','Eleanor 150/30ED','Evelyn 150/4-ED','Femme-Tab ED 30/150','Lenest 30 ED','Micronelle 30 ED','Monefeme','Seasonique','Microgynon 50 ED','Triquilar ED','Triphasil','Trifeme','Logynin ED','Microlut','Brevinor-1','Normin-1 28 Day','Noriday','Femme-Tab ED 20/100'])) {
        $('#callback-form').submit();  
      }else{
        $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
        $('.form_loop[data-question="do-you-have-a-medication-preference"]').addClass('d-block').find('.number').html($currentNumber + 1);
      }
    }


    
    CalculateP();
  }
  else {
    shakeEffect($parent);
    // errorPopUp();
    $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
    setTimeout(function(){ $('.valid_date_text').remove(); },2500);
  }
});

// STEP ???
$('.form_loop[data-question="what-is-your-ihi"] button').click(function(){
  ValidateRemove();
  var $this = $(this),
      $parent = $this.parents('.form_loop'),
      $currentNumber = parseInt($parent.find('.number').html()),
      $value = $parent.find('.details_filed input').val();
  if ($value != ''){
    // $parent.addClass('d-none').removeClass('d-block');
    CalculateP();
    $('.form-selected-answer [data-handle="what-is-your-ihi"]').val($value);

    var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medication-preference"]').data("question");
    var newValue = { 'what-is-your-ihi': $value };
    pushValueToCookieArray('birth-control', newValue,afterlastQuestion, $currentNumber + 1);
    if ($('.form-selected-answer [data-handle=' + getQuestion.que26 + ']').val() == 'Yes') {
      $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
      $('.form_loop[data-question="do-you-have-a-medication-preference"]').addClass('d-block').find('.number').html($currentNumber + 1);
    }else {
      var bmival = parseFloat($('.bmi-value').val());
      
      const getValIs = $('.form-selected-answer [data-handle=what-brand-are-you-after]').val();
      function containsAll(needles, haystack) {
          for (var i = 0; i < needles.length; i++) {
              if ($.inArray(needles[i], haystack) == -1) return false;
          }
          return true;
      }
      
      if(bmival > 35){
        $('#callback-form').submit();  
      }else{
        if($(`.form-selected-answer [data-handle=${getQuestion.que1}]`).val() == 'Yes'){
          
          if (containsAll([getValIs], ['Slinda'])) {
            $('#callback-form').submit();  
          }else if(containsAll([getValIs], ['Microlut'])){
            $('#callback-form').submit();  
          }else{
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
            $('.form_loop[data-question="do-you-have-a-medication-preference"]').addClass('d-block').find('.number').html($currentNumber + 1);
          }
        }else{
          if (containsAll([getValIs], ['Yasmin','Yaz','Microgynon 20 ED','Micronelle 20 ED','Nextstellis','Nuvaring','Estelle 35','Slinda','Zoely','Madeline'])) {
            $('#callback-form').submit();  
          } else if (containsAll([getValIs], ['Lenest 20 ED','Loette','Diane 35','Brenda 35','Petibelle'])) {
            $('#callback-form').submit();  
          } else if (containsAll([getValIs], ['Levlen ED','Eleanor 150/30ED','Evelyn 150/4-ED','Femme-Tab ED 30/150','Lenest 30 ED','Micronelle 30 ED','Monefeme','Seasonique','Microgynon 50 ED','Triquilar ED','Triphasil','Trifeme','Logynin ED','Microlut','Brevinor-1','Normin-1 28 Day','Noriday','Femme-Tab ED 20/100'])) {
            $('#callback-form').submit();  
          }else{
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
            $('.form_loop[data-question="do-you-have-a-medication-preference"]').addClass('d-block').find('.number').html($currentNumber + 1);
          }
        }
      }
      
    }
  }
  else {
    shakeEffect($parent);
    $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
    setTimeout(function(){ $('.valid_date_text').remove(); },2500);
  }
});


var $Form = $('#callback-form');
$Form.submit(function(e) {
    e.preventDefault();
    $('.loading-wrapper').show();
    ga('send', 'event', {
        eventCategory: 'contraception-questionnaire',
        eventAction: 'Submit',
        eventLabel: 'Contraception form',
        eventValue: 1
    });


    $Form.find("input[type='hidden']").each(function() {
      var get_data_handle = $(this).attr('data-handle');
  
      if(get_data_handle=='please-enter-your-medicare-card-details'){
          if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'no'){
            if($(this).val() == ""){
              $(this).remove();
            }    
          }
      }else{
        if($(this).val() == ""){
          $(this).remove();
        }
      }
    })

  const getValIs = $('.form-selected-answer [data-handle=what-brand-are-you-after]').val();
  function containsAll(needles, haystack) {
        for (var i = 0; i < needles.length; i++) {
            if ($.inArray(needles[i], haystack) == -1) return false;
        }
        return true;
    }
  var bmival = parseFloat($('.bmi-value').val());


    if ($('.form-selected-answer [data-handle=' + getQuestion.que25 + ']').val() == 'No') {
      var redirectionMainUrl = json['do-you-have-a-medication-preference-contraception'];
    }else{
      var medicationO = $('.form-selected-answer [data-handle=' + getQuestion.que21 + ']').val();
      var getDataO = findMedication(json, medicationO);
      
      if (getDataO.skipStrength == "true") {
        
        var redirectionMainUrl = getDataO.skipDirectUrl;
        
      }else {
      
        const medication = $('.form-selected-answer [data-handle=' + getQuestion.que21 + ']').val();
        const dosage = $('.form-selected-answer [data-handle=' + getQuestion.que22 + ']').val();
        var getData = findMedicationDosage(json, medication, dosage);
        var redirectionMainUrl = getData.url;
      }
    }


  var redirectionUrl;
  if (bmival > 35) {
      var redirectionUrl = 'https://bursthealth.com.au/products/contraception-treatment-plan-m';
  }else{
    if($(`.form-selected-answer [data-handle=${getQuestion.que1}]`).val() == 'Yes'){
      if (containsAll([getValIs], ['Slinda'])) {
        var redirectionUrl = 'https://bursthealth.com.au/products/contraception-treatment-plan-s-m';
      }else if(containsAll([getValIs], ['Microlut'])){
        var redirectionUrl = 'https://bursthealth.com.au/products/contraception-treatment-plan-m';
      }else{
        var redirectionUrl = redirectionMainUrl;
      }
    }else{
      if (containsAll([getValIs], ['Yasmin','Yaz','Microgynon 20 ED','Micronelle 20 ED','Nextstellis','Nuvaring','Estelle 35','Slinda','Zoely','Madeline'])) {
         var redirectionUrl = 'https://bursthealth.com.au/products/birth-control';
      } else if (containsAll([getValIs], ['Lenest 20 ED','Loette','Diane 35','Brenda 35','Petibelle'])) {
         var redirectionUrl = 'https://bursthealth.com.au/products/birth-control-3';
      } else if (containsAll([getValIs], ['Levlen ED','Eleanor 150/30ED','Evelyn 150/4-ED','Femme-Tab ED 30/150','Lenest 30 ED','Micronelle 30 ED','Monefeme','Seasonique','Microgynon 50 ED','Triquilar ED','Triphasil','Trifeme','Logynin ED','Microlut','Brevinor-1','Normin-1 28 Day','Noriday','Femme-Tab ED 20/100'])) {
          var redirectionUrl = 'https://bursthealth.com.au/products/birth-control-4';
      }else{
          var redirectionUrl = redirectionMainUrl;
      }
    }
  }


  console.log(redirectionUrl,"redirectionUrlredirectionUrl")

    var noscriptContent = $('#productString_url').html();
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    var urls = noscriptContent.match(urlRegex);
    
    $('.form-selected-answer').append(`<input type="hidden" name="Product redirection Url" value="${redirectionUrl}">`);
    $('.form-selected-answer').append(`<input type="hidden" name="Product Session id" value="${unique_id}">`);
    $.each(urls, function(index, url) {
     if (url.includes(redirectionUrl)) {
      $('.form-selected-answer').append(`<input type="hidden" name="Product String Url" value="true">`);
     }
    });

    $.ajax({
        url: $Form.attr('action'),
        cache: false,
        type: 'post',
        data: $Form.serialize(),
        success: function(itemData) {
            var data = JSON.parse(itemData);
            jQuery.post('/cart/update.js', "attributes[weightloss-uid]=" + data.unique_id);
            var cookieToDelete = 'birth-control';
            deleteCookie(cookieToDelete);
            deleteCookie("birth-control_lastQuestionafter");
            location.href = data.product_link;
          
        },
        error: function() {

        }
    });
});


function CalculateP() {
    var Length = $('.form-selected-answer input').length + 1,
        AnswerLength = 0,
        Percentage = 0;
    for (i = 1; i < Length; i++) {
        if ($('.form-selected-answer input:nth-child(' + i + ')').val() != '') {
            AnswerLength = parseInt(AnswerLength) + 1;
        }
    }
    Percentage = parseInt(AnswerLength / $('.form-selected-answer input').length * 100);
    $('.progress_content .progress_title span').html(Percentage);
    $('#form_progress_bar').css('width', Percentage + '%');
}

function pushHistory(number) {
    window.history.pushState("", "", location.pathname + "?question=" + number);
    ga('send', {
        hitType: 'pageview',
        page: location.pathname + location.search
    });
}

function ValidateRemove() {
    $('.form_loop .valid_date_text').remove();
}

function onmaxlength(e) {
    // var $this = $(e);
    // var maxlength = $this.attr('maxlength');
    // var value = $(e).val();
    // if (value && value.length > maxlength) {
    //     return false;
    // } else {
    //     return true;
    // }
}